/**
 * Extracts the session ID (`sid` claim) from a JWT token string.
 *
 * Decodes the base64url-encoded payload segment of the token and reads the
 * `sid` field. This is used to correlate instrumentation events with the
 * authenticated session, without ever forwarding the full token.
 *
 * Returns `null` when no token is present, when the token is malformed, or
 * when the payload does not contain a `sid` claim.
  * @notInstrumented
 */
// eslint-disable-next-line custom-rules/require-single-object-param
export const extractSessionId = (token: string): string | null => {
  try {
    const payload = token.split('.')[1];
    const decoded = JSON.parse(atob(payload));

    return decoded.sid ?? null;
  } catch {
    return null;
  }
};
